export const WORKAREAS_FETCH_REQUEST = "WORKAREAS_FETCH_REQUEST";
export const WORKAREAS_FETCH_SUCCESS = "WORKAREAS_FETCH_SUCCESS";
export const WORKAREAS_FETCH_FAIL = "WORKAREAS_FETCH_FAIL";

export const WORKAREAS_CLEAR_ERROR = "WORKAREAS_CLEAR_ERROR";
